module.exports = __webpack_public_path__ + "c55cf2a18be98fc85865712a8be8ccf1.jpg";